import { 
  TOP_UP_POST, 
  TOP_UP_HISTORY,
  AUTH_TOKEN_KEY
} from '../constants';
import fetch from '../utils/Api';

export const doTopUp = (payload)=>({
  type: TOP_UP_POST,
  payload: fetch({
    Authorization: 'Bearer '+localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .post(`/users/payments/top-up`, payload)
  .then(res =>  res.data)
})

export const walletHistory = (query) => ({
  type: TOP_UP_HISTORY,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  }).get('/users/top-up', query)
  .then(response => response.data)
})